import React, { useState } from 'react'

import DataTable from '@/components/datatable/DataTable'
import EditReferralLinkModal from '@/components/misc/ReferralLinksTable/components/EditReferralLinkCodeModal'
import ReferralLinksTableRow from '@/components/misc/ReferralLinksTable/components/ReferralLinksTableRow'
import { useIsViewingAsFromCompany } from '@/components/misc/ReferralLinksTable/hooks/useIsViewingAsFromCompany'
import { SHAREABLE_LINKS_TABLE_PAGE_SIZE } from '@/components/misc/ReferralLinksTable/lib/constants'
import { ReferralLinkTableRow } from '@/components/misc/ReferralLinksTable/types'
import SkeletonTable from '@/components/skeleton/SkeletonTable'
import { Pagination } from '@/components/ui/pagination'
import {
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
interface Props {
  referralLinks: ReferralLinkTableRow[]
  totalReferralLinks: number
  isLoading?: boolean
  activePage: number
  onPageChange: (page: number) => void
}

const ReferralLinksTable: React.FC<Props> = ({
  referralLinks,
  totalReferralLinks,
  isLoading,
  activePage,
  onPageChange,
}) => {
  const isViewingAsFromCompany = useIsViewingAsFromCompany()

  const [linkBeingEdited, setLinkBeingEdited] =
    useState<ReferralLinkTableRow | null>(null)

  if (isLoading) {
    return (
      <SkeletonTable rows={SHAREABLE_LINKS_TABLE_PAGE_SIZE + 1} columns={2} />
    )
  }

  return (
    <>
      <DataTable
        tableProps={{
          className: 'table-fixed',
          style: { minWidth: '600px' },
        }}
      >
        <TableHeader>
          <TableRow>
            <TableHead>
              {isViewingAsFromCompany ? 'Introduce to' : 'Partner company'}
            </TableHead>
            <TableHead style={{ width: '75px' }}>
              <Tooltip>
                <TooltipTrigger asChild>
                  <span>Referrals</span>
                </TooltipTrigger>
                <TooltipContent>
                  The number of referrals booked via this calendar link
                </TooltipContent>
              </Tooltip>
            </TableHead>
            <TableHead>Link</TableHead>
            <TableHead style={{ width: '170px' }}>Link actions</TableHead>
          </TableRow>
        </TableHeader>

        <TableBody>
          {referralLinks.map((link) => (
            <ReferralLinksTableRow
              referralLink={link}
              key={link['@id']}
              onEditClick={(referralLink) => setLinkBeingEdited(referralLink)}
            />
          ))}
        </TableBody>
      </DataTable>

      {totalReferralLinks > SHAREABLE_LINKS_TABLE_PAGE_SIZE && (
        <div className="mt-4">
          <Pagination
            activePage={activePage}
            totalItemsCount={totalReferralLinks}
            numItemsPerPage={SHAREABLE_LINKS_TABLE_PAGE_SIZE}
            onChange={onPageChange}
          />
        </div>
      )}

      {linkBeingEdited && (
        <EditReferralLinkModal
          referralLink={linkBeingEdited}
          onHide={() => setLinkBeingEdited(null)}
        />
      )}
    </>
  )
}

export default ReferralLinksTable
